import { pick } from 'ramda';

export function pluralize(num: number, singular: string, plural = singular + 's') {
  return num > 1 ? plural : singular;
}

export function toFixedIfFloat(num: number, decimals = 2) {
  return Number.isInteger(num) ? num : num.toFixed(decimals);
}

export function getRawUser<T extends RawUser>(user: T): RawUser {
  return pick(['userId', 'name', 'emailId'], user);
}
